import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

import { createTimeSeriesChartTheme } from './createTimeSeriesChartTheme';
import type { TimeSeriesChartTheme } from './TimeSeriesChartTheme.types';

export function useTimeSeriesChartTheme(): TimeSeriesChartTheme {
  const theme = useTheme();

  return useMemo(() => createTimeSeriesChartTheme(theme), [theme]);
}
